export class GetBillRefundsModel {

  public BillId: number;
}
